import { render, staticRenderFns } from "./DummyView.vue?vue&type=template&id=590fb408&scoped=true&lang=html&"
import script from "./DummyView.vue?vue&type=script&lang=js&"
export * from "./DummyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590fb408",
  null
  
)

export default component.exports